export default __webpack_public_path__ + "static/tooltip-info-dont-dark-9ef6fda91a2979b7f74d8882dd4c07fd.png";